import React from 'react';
import { Link } from 'react-router-dom';
import './CategoriesList.scss';
import readConfig from '../../../utils/readClientConfiguration';
import productionConfiguration from '../../../config/default.json';
import {getWebp} from "../../../utils/getWebp";

// Zabezpieczenie przed błędami odczytu konfiguracji
let cdnBaseUrl = '';
try {
  cdnBaseUrl = readConfig(productionConfiguration, 'cdn') || '';
} catch (error) {
  console.error('Error reading CDN configuration:', error);
  cdnBaseUrl = '';
}
const emmezetaPlaceholder = 'https://s3.emmezeta.hr/falcon/emmezeta-placeholder.png'
function getImageUrl(rawSource) {
  // Obsługa pustych lub nieprawidłowych wartości
  if (!rawSource || rawSource === 'false' || rawSource === false) {
    return emmezetaPlaceholder;
  }

  try {
    // Sprawdź, czy rawSource jest stringiem i czy możemy na nim wywołać .includes()
    if (typeof rawSource === 'string') {
      if (cdnBaseUrl && rawSource.includes(cdnBaseUrl)) {
        return `${rawSource}`;
      }

      if (rawSource.includes('https://')) {
        return rawSource;
      }

      // Jeśli mamy cdnBaseUrl, użyj go, w przeciwnym razie zwróć placeholder
      return cdnBaseUrl ? `${cdnBaseUrl}/${rawSource}` : emmezetaPlaceholder;
    }
  } catch (error) {
    console.error('Error in getImageUrl:', error);
  }

  // Fallback dla dowolnego innego przypadku
  return emmezetaPlaceholder;
}


const CategoriesList = ({ currentCategory }) => {
  // Sprawdzenie, czy mamy obiekt i czy zawiera tablicę dzieci
  if (!currentCategory || !currentCategory.children || !Array.isArray(currentCategory.children) || currentCategory.children.length === 0) {
    console.log('No valid children found for category', currentCategory);
    return null;
  }

  return (
    <div className="categories-list">
      {currentCategory.children.map((child, index) => {
        // Sprawdźmy, czy obiekt dziecka ma wszystkie potrzebne właściwości
        if (!child || !child.name || !child.canonical_url || !child.current_store_paths) {
          console.warn('Invalid child category data', child);
          return null;
        }

        let baseUrl = emmezetaPlaceholder;
        try {
          // Bezpieczny dostęp do danych
          if (Array.isArray(child.current_store_paths) &&
            child.current_store_paths.length > 0 &&
            child.current_store_paths[0] &&
            child.current_store_paths[0].base_url_image) {
            baseUrl = getWebp(getImageUrl(child.current_store_paths[0].base_url_image));
          }
        } catch (error) {
          console.error('Error processing child category image:', error);
        }

        return (
          <Link to={`/${child.canonical_url}`} key={child.name || `category-${index}`}>
            <div className="categories-list__item" style={{
              backgroundImage: `url("${baseUrl}")`
            }} />
            <div className="categories-list__name">{child.name}</div>
          </Link>
        );
      }).filter(Boolean)} {/* Usuwamy nullowe elementy */}
    </div>
  );
};

export default CategoriesList;
